import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const tasksFiltersSlice = createSlice({
  name: "Task Filter",
  initialState,
  reducers: {
    applyFilter: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    resetFilters: () => {
      return initialState;
    },
    resetFilterByKey: (state, action) => {
      const key = action.payload.key;
      delete state[key];
    },
  },
});

export const { applyFilter, resetFilters, resetFilterByKey } = tasksFiltersSlice.actions;
export default tasksFiltersSlice.reducer;
